module.exports = __webpack_public_path__ + "img/joint-mob.eeb0ff64.png";